import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';
import { triggerBlobDownload } from '@/utils/attachmentDownload';

export const exportService = {
  /** Download workspace tasks as GeoJSON file */
  downloadGeoJson: async (): Promise<void> => {
    const response = await apiClient.get(API_ENDPOINTS.EXPORT.GEOJSON, {
      responseType: 'arraybuffer',
    });

    const contentDisposition = response.headers['content-disposition'] as
      | string
      | undefined;
    const fileName = extractFileName(contentDisposition) ?? 'export.geojson';

    triggerBlobDownload(
      response.data as ArrayBuffer,
      fileName,
      'application/geo+json'
    );
  },
};

function extractFileName(
  contentDisposition: string | undefined
): string | null {
  if (!contentDisposition) return null;

  const match = /filename[^;=\n]*=["']?([^"';\n]*)["']?/.exec(
    contentDisposition
  );
  return match?.[1] ?? null;
}
